import { defineMessages } from "react-intl";

export const courses = defineMessages({
  addCourse: {
    id: "component.courses.addCourse",
    defaultMessage: "Aggiungi un corso",
  },
});
